export default svColor => {
  const color = svColor.toLowerCase()
  if (color === 'röd') {
    return 'red'
  }

  if (color === 'orange') {
    return 'orange'
  }

  if (color === 'gul') {
    return 'yellow'
  }

  return 'grey'
}
